/* eslint-disable react/destructuring-assignment */

export const WalletUsdtIcon = props => {
  return (
    (<svg
      width="20px"
      height="22px"
      viewBox="0 0 20 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      data-palette="WalletUsdtIcon">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Trading_post-login-wallet" transform="translate(-883.000000, -352.000000)">
          <g id="wlalet" transform="translate(847.000000, 56.000000)">
            <g id="Group-6" transform="translate(10.000000, 89.000000)">
              <g id="Group-6-Copy-3" transform="translate(11.000000, 97.000000)">
                <g id="USDT" transform="translate(15.000000, 110.918919)">
                  <path
                    d="M10,0 C15.5228475,-1.01453063e-15 20,4.4771525 20,10 L20,10.5135135 C20,16.036361 15.5228475,20.5135135 10,20.5135135 C4.4771525,20.5135135 2.45271059e-15,16.036361 0,10.5135135 L0,10 C1.10000309e-15,4.4771525 4.4771525,1.01453063e-15 10,0 Z"
                    id="Rectangle-Copy"
                    fill="var(--brand-bg-primary)"
                    fillRule="nonzero"
                  />
                  <g
                    id="tether-usdt-logo"
                    transform="translate(5.000000, 6.000000)"
                    fill="#FFFFFF"
                  >
                    <path
                      d="M6.01733037,4.9514655 L6.01733037,4.9514655 C5.96050949,4.95572707 5.66693499,4.97324684 5.01207444,4.97324684 C4.49121644,4.97324684 4.12140726,4.9576211 3.99166627,4.9514655 L3.99166627,4.9514655 C1.97878687,4.86291965 0.476348312,4.51252427 0.476348312,4.09299683 C0.476348312,3.67346939 1.97878687,3.32354752 3.99166627,3.23358114 L3.99166627,4.60249065 C4.12330129,4.61196079 4.50021308,4.63421564 5.02107107,4.63421564 C5.64610067,4.63421564 5.95908897,4.60817274 6.01543634,4.60296416 L6.01543634,3.23452815 C8.02405417,3.32402102 9.52317818,3.6744164 9.52317818,4.09299683 C9.52317818,4.51157725 8.02452768,4.86197263 6.01543634,4.950992 L6.01543634,4.950992 L6.01733037,4.9514655 Z M6.01733037,3.09294948 L6.01733037,1.86798617 L8.82049339,1.86798617 L8.82049339,0 L1.18850324,0 L1.18850324,1.86798617 L3.99119276,1.86798617 L3.99119276,3.09247597 C1.7131493,3.19712108 0,3.6483735 0,4.1891188 C0,4.7298641 1.7131493,5.18064302 3.99119276,5.28576164 L3.99119276,9.21113689 L6.01685686,9.21113689 L6.01685686,5.28434111 C8.28969175,5.17969601 10,4.72891709 10,4.1886453 C10,3.6483735 8.29111227,3.19759458 6.01685686,3.09247597 L6.01685686,3.09247597 L6.01733037,3.09294948 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const WalletDetoIcon = props => {
  return (
    (<svg
      width="20px"
      height="22px"
      viewBox="0 0 20 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      data-palette="WalletDetoIcon">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Trading_post-login-wallet"
          transform="translate(-884.000000, -447.000000)"
          fillRule="nonzero"
        >
          <g id="wlalet" transform="translate(847.000000, 56.000000)">
            <g id="Group-6" transform="translate(10.000000, 89.000000)">
              <g id="Group-6-Copy-3" transform="translate(11.000000, 97.000000)">
                <g id="Rectangle-Copy-4" transform="translate(16.000000, 205.918919)">
                  <path
                    d="M10,0 C15.5228475,-1.01453063e-15 20,4.4771525 20,10 L20,10.5135135 C20,16.036361 15.5228475,20.5135135 10,20.5135135 C4.4771525,20.5135135 2.45271059e-15,16.036361 0,10.5135135 L0,10 C1.10000309e-15,4.4771525 4.4771525,1.01453063e-15 10,0 Z"
                    id="Rectangle-Copy"
                    fill="#FBBE1D"
                  />
                  <g
                    id="DETO-logo"
                    transform="translate(4.000000, 5.160844)"
                    fill="#FFFFFF"
                  >
                    <polygon
                      id="Combined-Shape"
                      points="4.77428716 0 12 3.61285642 12 7.22571282 4.77428716 10.8385693 4.77428716 7.22571282 8.38714356 5.41928464 4.77428716 3.61285642"
                    />
                    <polygon
                      id="Combined-Shape-path"
                      points="3.61285642 3.61285642 3.61285642 7.22571282 0 5.41928464"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const WalletEthIcon = props => {
  return (
    (<svg
      width="24px"
      height="25px"
      viewBox="0 0 24 25"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      data-palette="WalletEthIcon">
      <g id="Mobile" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="M5-New-header-mobile-inside-Copy-10"
          transform="translate(-19.000000, -363.000000)"
          fillRule="nonzero"
        >
          <g id="Group-6" transform="translate(0.000000, 170.000000)">
            <g id="Group-6-Copy-6" transform="translate(15.000000, 181.000000)">
              <g id="Group-8" transform="translate(4.000000, 6.000000)">
                <g id="Rectangle-Copy-3" transform="translate(0.000000, 6.918919)">
                  <path
                    d="M12,0 C18.627417,-1.21743675e-15 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 8.11624501e-16,18.627417 0,12 C-8.11624501e-16,5.372583 5.372583,1.21743675e-15 12,0 Z"
                    id="Rectangle-Copy-2"
                    fill="#7A82B5"
                  />
                  <g
                    id="ethereum-eth-logo-copy"
                    transform="translate(7.000000, 4.000000)"
                  >
                    <polygon
                      id="Path"
                      fill="#E2E2E2"
                      points="4.99853386 0 4.88927419 0.371125872 4.88927419 11.1393857 4.99853386 11.2483904 9.99694022 8.29378992"
                    />
                    <polygon
                      id="Path"
                      fill="#FFFFFF"
                      points="4.99853386 0 0 8.29378992 4.99853386 11.2483904 4.99853386 6.02177544"
                    />
                    <polygon
                      id="Path"
                      fill="#E2E2E2"
                      points="4.99853386 12.194755 4.93695577 12.2698471 4.93695577 16.1056644 4.99853386 16.2854265 10 9.24168441"
                    />
                    <polygon
                      id="Path"
                      fill="#FFFFFF"
                      points="4.99853386 16.2854265 4.99853386 12.194755 0 9.24168441"
                    />
                    <polygon
                      id="Path"
                      fill="#C4C1C1"
                      points="4.99853386 11.2483904 9.99694022 8.29378992 4.99853386 6.02177544"
                    />
                    <polygon
                      id="Path"
                      fill="#E2E2E2"
                      points="0 8.29378992 4.99853386 11.2483904 4.99853386 6.02177544"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const WalletUSDCIcon = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      fill="none"
      viewBox="0 0 120 120"
      className={props.className}
      data-palette="WalletUSDCIcon">
      <path
        fill="#2775CA"
        d="M60 120c33.25 0 60-26.75 60-60S93.25 0 60 0 0 26.75 0 60s26.75 60 60 60z"
      />
      <path
        fill="#fff"
        d="M76.5 69.5c0-8.75-5.25-11.75-15.75-13-7.5-1-9-3-9-6.5s2.5-5.75 7.5-5.75c4.5 0 7 1.5 8.25 5.25.25.75 1 1.25 1.75 1.25h4c1 0 1.75-.75 1.75-1.75v-.25c-1-5.5-5.5-9.75-11.25-10.25v-6c0-1-.75-1.75-2-2H58c-1 0-1.75.75-2 2v5.75c-7.5 1-12.25 6-12.25 12.25 0 8.25 5 11.5 15.5 12.75 7 1.25 9.25 2.75 9.25 6.75s-3.5 6.75-8.25 6.75c-6.5 0-8.75-2.75-9.5-6.5-.25-1-1-1.5-1.75-1.5h-4.25c-1 0-1.75.75-1.75 1.75v.25c1 6.25 5 10.75 13.25 12v6c0 1 .75 1.75 2 2H62c1 0 1.75-.75 2-2v-6c7.5-1.25 12.5-6.5 12.5-13.25z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M25 47.75c-7.25 19.25 2.75 41 22.25 48 .75.5 1.5 1.5 1.5 2.25v3.5c0 .5 0 .75-.25 1-.25 1-1.25 1.5-2.25 1C32.25 99 21.5 88.25 17 74.25c-7.5-23.75 5.5-49 29.25-56.5.25-.25.75-.25 1-.25 1 .25 1.5 1 1.5 2V23c0 1.25-.5 2-1.5 2.5C37 29.25 28.75 37.25 25 47.75zm46.5-29c.25-1 1.25-1.5 2.25-1C87.5 22.25 98.5 33 103 47.25c7.5 23.75-5.5 49-29.25 56.5-.25.25-.75.25-1 .25-1-.25-1.5-1-1.5-2v-3.5c0-1.25.5-2 1.5-2.5C83 92.25 91.25 84.25 95 73.75c7.25-19.25-2.75-41-22.25-48-.75-.5-1.5-1.5-1.5-2.5v-3.5c0-.5 0-.75.25-1z"
        clipRule="evenodd"
      />
    </svg>)
  );
};

export const WalletDepositIcon = props => {
  return (
    (<svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      data-palette="WalletDepositIcon">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Trading_post-login-wallet" transform="translate(-892.000000, -207.000000)">
          <g id="wlalet" transform="translate(847.000000, 56.000000)">
            <g id="Group-6" transform="translate(10.000000, 89.000000)">
              <g id="btn-copy" transform="translate(26.000000, 57.000000)">
                <g id="Group" transform="translate(9.000000, 5.000000)">
                  <polygon id="Path" points="0 0 18 0 18 18 0 18" />
                  <polygon
                    id="Path"
                    fill="var(--brand-bg-primary)"
                    fillRule="nonzero"
                    transform="translate(9.007875, 9.007875) scale(-1, -1) translate(-9.007875, -9.007875) "
                    points="7.0605 6 13.51575 12.45525 12.45525 13.51575 6 7.0605 6 12.75 4.5 12.75 4.5 4.5 12.75 4.5 12.75 6"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const WalletWithdrawalIcon = props => {
  return (
    (<svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      data-palette="WalletWithdrawalIcon">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Trading_post-login-wallet" transform="translate(-984.000000, -207.000000)">
          <g id="wlalet" transform="translate(847.000000, 56.000000)">
            <g id="Group-6" transform="translate(10.000000, 89.000000)">
              <g id="btn" transform="translate(123.000000, 57.000000)">
                <g id="Group" transform="translate(4.000000, 5.000000)">
                  <polygon id="Path" points="0 0 18 0 18 18 0 18" />
                  <polygon
                    id="Path"
                    fill="var(--brand-bg-primary)"
                    fillRule="nonzero"
                    points="7.0605 6 13.51575 12.45525 12.45525 13.51575 6 7.0605 6 12.75 4.5 12.75 4.5 4.5 12.75 4.5 12.75 6"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const WalletConvertIcon = props => {
  return (
    (<svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      data-palette="WalletConvertIcon">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Trading_post-login-wallet"
          transform="translate(-1087.000000, -208.000000)"
        >
          <g id="wlalet" transform="translate(847.000000, 56.000000)">
            <g id="Group-6" transform="translate(10.000000, 89.000000)">
              <g id="btn-copy-4" transform="translate(221.000000, 57.000000)">
                <g id="Group" transform="translate(9.000000, 6.000000)">
                  <polygon id="Path" points="0 0 16 0 16 16 0 16" />
                  <path
                    d="M3.582,3.00666667 C4.79979962,1.92625129 6.37201759,1.3307681 8,1.33332508 C11.682,1.33332508 14.6666751,4.318 14.6666751,8 C14.6688353,9.36260211 14.2514915,10.6928418 13.4713333,11.81 L11.6666667,8 L13.3333333,8 C13.3333733,5.83090583 12.0197248,3.87786027 10.0106838,3.06010479 C8.00164289,2.24234931 5.69746789,2.72280418 4.18266667,4.27533333 L3.58266667,3.00733333 L3.582,3.00666667 Z M12.418,12.9933333 C11.2002004,14.0737487 9.62798241,14.6692319 8,14.6666749 C4.318,14.6666749 1.33333333,11.682 1.33333333,8 C1.33333333,6.58333333 1.77533333,5.27 2.52866667,4.19 L4.33333333,8 L2.66666667,8 C2.66662675,10.1690942 3.98027524,12.1221397 5.98931617,12.9398952 C7.99835711,13.7576507 10.3025321,13.2771958 11.8173333,11.7246667 L12.4173333,12.9926667 L12.418,12.9933333 Z"
                    id="Shape"
                    fill="var(--brand-bg-primary)"
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const SuitcaseIcon = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={props.className}
      data-palette="SuitcaseIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L16 0 16 16 0 16z"
                  transform="translate(-890 -586) translate(847 51) translate(35 529) translate(8 6)"
                />
                <path
                  fill="var(--brand-bg-primary)"
                  fillRule="nonzero"
                  d="M4.667 3.333v-2c0-.368.298-.666.666-.666h5.334c.368 0 .666.298.666.666v2H14c.368 0 .667.299.667.667v9.333c0 .369-.299.667-.667.667H2c-.368 0-.667-.298-.667-.667V4c0-.368.299-.667.667-.667h2.667zm-2 7.334v2h10.666v-2H2.667zm0-1.334h10.666V4.667H2.667v4.666zM6 2v1.333h4V2H6zm1.333 5.333h1.334v1.334H7.333V7.333z"
                  transform="translate(-890 -586) translate(847 51) translate(35 529) translate(8 6)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const PlusIcon = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      className={props.className}
      data-palette="PlusIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L18 0 18 18 0 18z"
                  transform="translate(-889 -585) translate(847 51) translate(35 529) translate(7 5)"
                />
                <path
                  fill="var(--brand-bg-primary)"
                  fillRule="nonzero"
                  d="M8.25 8.25L8.25 3.75 9.75 3.75 9.75 8.25 14.25 8.25 14.25 9.75 9.75 9.75 9.75 14.25 8.25 14.25 8.25 9.75 3.75 9.75 3.75 8.25z"
                  transform="translate(-889 -585) translate(847 51) translate(35 529) translate(7 5)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};
